<template>
    <section>
        <div class="container">
            <h2>{{ title }}</h2>

            <div v-html="content"></div>

            <ul>
                <li v-for="item in list">
                    <span class="icon-wrap" v-html="item.icon"></span>
                    <div>
                       <strong>{{ item.title }}</strong>
                       <p>{{ item.description }}</p>
                   </div>
                </li>
            </ul>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    section {
        h2 {
            font-size: 38px;
            text-align: center;
        }

        ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            list-style: none;
            padding: 32px 0 0;
            margin: 0;

            li {
                display: flex;
                width: 100%;
                max-width: 465px;
                padding: 12px;

                .icon-wrap {
                    width: 78px;
                    max-width: 78px;
                    margin-right: 16px;
                }

                div {
                    width: calc(100% - 78px);

                    strong {
                        font-size: 26px;
                        color: var(--color-gray-dark-content);
                        line-height: 1;
                    }

                    p {
                        font-size: 18px;
                        color: var(--color-gray-medium-content);
                    }
                }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            content: String,
            list: {
                type: Array,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
        },
    }
</script>
